module.exports = __webpack_public_path__ + "img/4.553856c4.jpg";